<script setup lang="ts">
import { inject, ref } from 'vue'
import { customElementPropsKey } from '../types/customElementProps.types'
import { mdiLightbulbOutline } from '@mdi/js'
import LegalConditions from './LegalConditions.vue'
import LanguageSelection from './LanguageSelection.vue'

const templateProps = inject(customElementPropsKey)
const imgPath = ref(`${templateProps?.resourcesPath}/img/sm-login.png`)
</script>
<template>
  <v-container class="pa-0 h-100" fluid>
    <v-row class="h-100">
      <v-col :cols="0" :md="6" class="bg-white d-none d-md-block">
        <v-container class="d-flex flex-column align-center h-100">
          <v-row class="d-flex justify-center">
            <v-col
              :cols="12"
              :lg="8"
              :xl="6"
              class="d-flex flex-column justify-center"
            >
              <div>
                <v-img :src="imgPath" width="100%" class="my-6" />
                <v-alert
                  class="text-medium-emphasis my-6"
                  :icon="mdiLightbulbOutline"
                  color="white"
                >
                  <span class="text-body-2"
                    >{{ $t('on-boarding.sign-in.screen.infobar') }}
                  </span>
                </v-alert>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
      <v-col :cols="12" :md="6" class="d-flex flex-column align-center">
        <div
          class="d-flex flex-column align-center justify-center h-100 w-100 px-8"
        >
          <v-container class="d-flex flex-column align-center">
            <v-row class="d-flex justify-center w-100">
              <v-col :cols="12" :sm="8" :md="12" :lg="8" :xl="6">
                <slot />
              </v-col>
            </v-row>
          </v-container>
        </div>
        <LanguageSelection />
        <LegalConditions />
      </v-col>
    </v-row>
  </v-container>
</template>
